<template>
  <WidgetUnlockDownload
    ref="unlockDownload"
    @close="onCloseUnlockDownload"
    @enable="onEnableDownload"
    :endpoint="`${runtimeConfig.public.noderedURL}/enable-download-zava`"
    :show="showUnlockDownload"
  />
  <section id="pageProductDownload" class="page-product-download">
    <div class="row-1 p-top-3 p-bot-3">
      <!-- Title -->
      <div>
        <h2 class="text-xl">
          {{ $t(`pages.product.downloadTitle`) }}
        </h2>
      </div>
      <!-- Content -->
      <div class="page-product-download__buttons m-top-5" v-if="hasDownloads">
        <!-- 3d -->
        <button
          v-if="product.productDownloadFile3d"
          @click="onDownload(product.productDownloadFile3d)"
          class="page-product-download__button button-round-1 --transparent-light"
          :class="{
            '--enabled': enabledToDownload,
          }"
        >
          <span class="page-product-download__button__label">
            <img
              v-if="!enabledToDownload"
              :src="arrowLock"
              alt="Ico lock light"
            />
            {{ $t('pages.product.productDownloadFile3d') }}</span
          >
          <span class="text-xs">{{ $t(`cta.download`) }}</span>
        </button>

        <!-- Disegno tecnico -->
        <button
          v-if="product.productDownloadDisegnoTecnico"
          @click="
            onDownload(product.productDownloadDisegnoTecnico, {
              allowDownload: true,
            })
          "
          class="page-product-download__button button-round-1 --transparent-light"
          :class="{
            '--enabled': true,
          }"
        >
          <span class="page-product-download__button__label">
            {{ $t('pages.product.productDownloadDisegnoTecnico') }}</span
          >
          <span class="text-xs">{{ $t(`cta.download`) }}</span>
        </button>

        <!-- Scheda tecnica -->
        <button
          v-if="technicalSheet"
          @click="onDownload(technicalSheet, { allowDownload: true })"
          class="page-product-download__button button-round-1 --transparent-light"
          :class="{
            '--enabled': true,
          }"
        >
          <span class="page-product-download__button__label">
            {{ $t('pages.product.productDownloadSchedaTecnica') }}</span
          >
          <span class="text-xs">{{ $t(`cta.download`) }}</span>
        </button>

        <!-- Istruzioni di montaggio -->
        <button
          v-if="instructions"
          @click="onDownload(instructions, { allowDownload: true })"
          class="page-product-download__button button-round-1 --transparent-light"
          :class="{
            '--enabled': true,
          }"
        >
          <span class="page-product-download__button__label">
            {{ $t('pages.product.productDownloadIstruzioniDiMontaggio') }}</span
          >
          <span class="text-xs">{{ $t(`cta.download`) }}</span>
        </button>

        <!-- Fotometria -->
        <button
          v-if="product.productDownloadFotometria"
          @click="
            onDownload(product.productDownloadFotometria, {
              allowDownload: true,
            })
          "
          class="page-product-download__button button-round-1 --transparent-light"
          :class="{
            '--enabled': true,
          }"
        >
          <span class="page-product-download__button__label">
            {{ $t('pages.product.productDownloadFotometria') }}</span
          >
          <span class="text-xs">{{ $t(`cta.download`) }}</span>
        </button>
      </div>
      <div class="page-product-download__buttons m-top-5" v-else>
        <p class="text-s">{{ $t('pages.product.noDownloadTitle') }}</p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'PagesProductDownload',
}
</script>

<script setup>
import arrowLock from '~/assets/img/ico/ico-lock-light.svg'

const props = defineProps({
  product: Object,
})

const { locale } = useI18n()

const runtimeConfig = useRuntimeConfig()

const enabledToDownload = useCookie('enabledToDownload', { maxAge: 86400 }) // durata 1 giorno

const unlockDownload = ref(null)
const downloadUrl = ref(null)
const showUnlockDownload = ref(null)

const instructions = computed(() => {
  return locale.value === 'en-us'
    ? props.product.productDownloadIstruzioniDiMontaggioUsa
    : props.product.productDownloadIstruzioniDiMontaggio
})

const technicalSheet = computed(() => {
  return locale.value === 'en-us'
    ? props.product.productDownloadSchedaTecnicaUsa
    : props.product.productDownloadSchedaTecnica
})

const hasDownloads = computed(() => {
  return (
    props.product.productDownloadFile3d ||
    props.product.productDownloadDisegnoTecnico ||
    props.product.productDownloadSchedaTecnica ||
    props.product.productDownloadIstruzioniDiMontaggio ||
    props.product.productDownloadFotometria
  )
})

const onDownload = (url, { allowDownload = false } = {}) => {
  const regex = /https:\/\/drive\.google\.com\/file\/d\/(.*?)\/view/g
  const id = regex.exec(url)
  downloadUrl.value = `https://drive.google.com/uc?export=download&id=${id[1]}`
  if (allowDownload || !unlockDownload || enabledToDownload.value) {
    download(downloadUrl.value)
  } else {
    //enabledToDownload.value = true
    showUnlockDownload.value = true
  }
}

const download = (url) => {
  window.location.href = url
}

const onCloseUnlockDownload = () => {
  showUnlockDownload.value = false
}

const onEnableDownload = () => {
  enabledToDownload.value = true
  download(downloadUrl.value)
}
</script>

<style lang="scss">
@import './style.scss';
</style>
